var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_c('portal', {
    attrs: {
      "to": "multiPart-tabs"
    }
  }, [_c('div', {
    attrs: {
      "id": "multiPart-tab-container"
    }
  }, [_c('div', {
    class: {
      'current-tab': _vm.isOnFirstTab,
      'multiPart-tab': true
    }
  }, [_vm._v("1")]), _c('div', {
    class: {
      'current-tab': !_vm.isOnFirstTab,
      'multiPart-tab': true
    }
  }, [_vm._v("2")])])]), _c('div', {
    attrs: {
      "id": "scrollable-text-and-question-container"
    }
  }, [_c('keyboard-adaptation-wrapper', {
    staticClass: "scrollable-text-wrapper",
    attrs: {
      "defaultHeight": 330
    }
  }, [_c('section', {
    attrs: {
      "id": "scrollable-text-section"
    }
  }, [_c('div', {
    attrs: {
      "id": "scrollable-text-container"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.scrollableHtml
    }
  })], 1)])]), _c('section', {
    class: {
      'question-text-section': true,
      tablet: _vm.isTablet
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOnFirstTab,
      expression: "isOnFirstTab"
    }]
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.multiSelectQuestionText
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isOnFirstTab,
      expression: "!isOnFirstTab"
    }]
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.constructAResponseQuestionText
    }
  })], 1), !_vm.isOnFirstTab ? _c('div', {
    staticStyle: {
      "height": "168px"
    }
  }, [_c('text-editor', {
    staticClass: "text-editor",
    attrs: {
      "autoFocus": true,
      "editable": !_vm.isTablet,
      "maxLength": _vm.currentRound.constructAResponse && _vm.currentRound.constructAResponse.maxCharacterCount
    },
    model: {
      value: _vm.keyboardHtml,
      callback: function ($$v) {
        _vm.keyboardHtml = $$v;
      },
      expression: "keyboardHtml"
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "multi-select-container"
  }, [_vm.isOnFirstTab && _vm.currentRound.multiSelect ? _c('section', {
    staticClass: "multi-select-section"
  }, [_c('multi-select-check-boxes', {
    attrs: {
      "answers": _vm.currentRound.multiSelect.answers,
      "lockedAnswers": _vm.lockedCheckBoxSelections,
      "maxCheckBoxSelections": _vm.maxMultiSelectAnswers,
      "resetCheckBoxAfterErrors": true,
      "showErrors": _vm.activityStatus.showErrors,
      "showHints": _vm.activityStatus.showHints,
      "showSuccess": true
    },
    on: {
      "onCheckBoxesSelectionChange": _vm.handleOnCheckBoxesSelectionChange
    }
  })], 1) : _vm._e()]), !_vm.isOnFirstTab ? _c('section', {
    staticClass: "keyboard-container"
  }, [_vm._t("keyboard")], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }